import Fingerprint2 from 'fingerprintjs2'
import UAParser from 'ua-parser-js'
import _ from 'lodash'
import { Cookie } from 'tough-cookie'
const COOKIE_NAME = '__farsoft_fingerprint'

export default class FingerPrint {
  constructor (fingerprintService, cookieService) {
    this.fingerprintService = fingerprintService || Fingerprint2
    this.cookieService = cookieService || Cookie

    this.default_options = {
      excludeAdBlock: true,
      preprocessor: this._preprocessor(),
      excludes: {
        adBlock: true,
        fonts: true,
        fontsFlash: true,
        enumerateDevices: true, // TEMOS QUE EXCLUIR DEVIDO AO BUG, SENAO FICA ALTERANDO
        availableScreenResolution: true,
        doNotTrack: true,
        localStorage: true,
        addBehavior: true,
        // cpuClass: true,
        // canvas: true,
        // webdriver: true,
        colorDepth: true,
        // deviceMemory: true,
        // hardwareConcurrency: true, // usamos ele pra atribuir o seed na função abaixo
        timezoneOffset: true,
        sessionStorage: true,
        indexedDb: true,
        openDatabase: true,
        plugins: true,
        webgl: true,
        webglVendorAndRenderer: true,
        hasLiedLanguages: true,
        touchSupport: true,
        hasLiedResolution: true,
        hasLiedOs: true,
        hasLiedBrowser: true,
        audio: true
      }
    }
  }

  run () {
    setTimeout(this._run.bind(this), 500)
  }

  _run () {
    this.fingerprintCookie = this._getCookie()
    this.container = document.querySelector('#hash-container')
    this._getFingerprint(this._writeHash)
  }

  _getCookie () {
    var cookies = (!document.cookie) ? [] : document.cookie.split(';')
    cookies = _.map(cookies, c => this.cookieService.parse(c))
    return _.find(cookies, c => c.key === COOKIE_NAME)
  }

  _getFingerprint (cb) {
    this.fingerprintService.get(this.default_options, cb.bind(this))
  }

  _writeHash (components) {
    // console.log('componentes aqui', components)
    const seed = _.find(components, (obj) => obj.key === 'hardwareConcurrency').value
    const hash = this.fingerprintService.x64hash128(
      components.map((pair) => pair.value).join(), seed
    )
    this.container.innerText = hash
    if (this._fingerprintHasChanged(hash)) {
      // console.log('Mudou de Equipamento!')
      // REMOVE os dados do localStorage para forçar o reload mandar o user para o login
      window.localStorage.removeItem('userInfo')
      window.localStorage.removeItem('fingerprint')
      window.localStorage.clear()
      alert('Identificado novo Equipamento, favor logar-se novamente!')
      window.location.reload(true)
    }
    document.cookie = new Cookie(
      {
        key: COOKIE_NAME,
        value: hash,
        expires: Infinity,
        maxAge: 'Infinity'
      }
    ).cookieString()
  }

  _fingerprintHasChanged (hash) {
    return !!((this.fingerprintCookie && hash !== this.fingerprintCookie.value))
  }

  _preprocessor (key, value) {
    if (key === 'userAgent') {
      var parser = new UAParser(value) // https://github.com/faisalman/ua-parser-js
      var userAgentMinusVersion = parser.getOS().name + ' ' + parser.getBrowser().name
      return userAgentMinusVersion
    }
    return value
  }
}
